import * as Base from "./MaturaQuadraticVietaParamOpenTask";

const TYPE = "MaturaQuadraticVietaSumSquaresParamOpenTask";

export function generateTask(options = {}) {
  return Base.createTask("vieta-equation", TYPE, options);
}

export const renderTask = Base.renderTask;
export const renderInput = Base.renderInput;
export const checkAnswer = Base.checkAnswer;
export const renderAnswer = Base.renderAnswer;
export const renderUserAnswer = Base.renderUserAnswer;
export const renderExplanation = Base.renderExplanation;

export default {
  generateTask,
  renderTask,
  renderInput,
  checkAnswer,
  renderAnswer,
  renderUserAnswer,
  renderExplanation,
};
